/**
 * A type guard to check if an error object in an Axios error.
 * @packageDocumentation
 */
export * from './isAxiosError'
